import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetStudentsIndividualWorkloadReportUseCaseInterface } from 'domain/usecases';

export class RemoteGetStudentsIndividualWorkloadReport
  implements GetStudentsIndividualWorkloadReportUseCaseInterface
{
  constructor(
    private readonly baseUrl: string,
    private readonly httpClient: HttpClient<GetStudentsIndividualWorkloadReportUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetStudentsIndividualWorkloadReportUseCaseInterface.Params,
  ): Promise<GetStudentsIndividualWorkloadReportUseCaseInterface.Result> {
    const adjustedParams = { ...params };

    const urlWithType = `${this.baseUrl}/${adjustedParams.type}`;

    delete adjustedParams.type;

    const requestUrl = generateUrl(urlWithType, adjustedParams);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: params.type !== '2' ? 'arraybuffer' : 'json',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(
          httpResponse.body.message ||
            'Algo inesperado aconteceu. Tente novamente em breve.',
        );
    }
  }
}
